import { ORDEN_ESTADO, ESTADOS } from "./constants";
import Papa from "papaparse";


// FECHA MES ISO 
export function getISOMonth(date) {
  return { year: date.getFullYear(), month: date.getMonth() + 1 };
}

export function monthKey(y, m) {
  return `${y}-M${String(m).padStart(2, "0")}`;
}

export function fmtMonthRange(y, m) {
  const date = new Date(Date.UTC(y, m - 1, 1));
  const monthName = date.toLocaleDateString("es-AR", { month: "long", timeZone: "UTC" });
  return monthName.charAt(0).toUpperCase() + monthName.slice(1) + ` de ${y}`;
}

export function fmtDatetime(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-AR") + " " +
    d.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });
}

export function uid() {
  return Math.random().toString(36).slice(2, 10);
}


// LÓGICA DE NEGOCIO
export function estadoActual(t) {
  if (!t.avances?.length) return "Planificada";
  const allFinished = t.avances.every(a => a.estado === "Terminada");
  const lastState = t.avances[t.avances.length - 1].estado;
  if (lastState === "Terminada" && !allFinished) {
    const lastUnfinished = [...t.avances].reverse().find(a => a.estado !== "Terminada");
    return lastUnfinished ? lastUnfinished.estado : "Avanzando";
  }
  return lastState;
}

export function tareasSorted(tareas) {
  return [...(tareas || [])].sort(
    (a, b) => ORDEN_ESTADO.indexOf(estadoActual(a)) - ORDEN_ESTADO.indexOf(estadoActual(b))
  );
}

export function contadores(tareas) {
  const c = Object.fromEntries(Object.keys(ESTADOS).map(k => [k, 0]));
  (tareas || []).forEach(t => { const e = estadoActual(t); if (c[e] !== undefined) c[e]++; });
  return c;
}

// CSV PARSING 
export function parseCsv(text) {

  if (typeof Papa === "undefined") {
    console.error("PapaParse no está cargado");
    return null;
  }

  const r = Papa.parse(text, { header: true, skipEmptyLines: true });
  if (!r.data?.length) return null;
  const cols = Object.keys(r.data[0]);
  const find = (...opts) => cols.find(c => opts.some(o => c.toLowerCase().includes(o.toLowerCase())));

  const cKey = find("Issue Key", "Clave", "Key");
  const cTitle = find("Summary", "Resumen", "Título", "Titulo", "Title");
  const cAssign = find("Assignee", "Responsable", "Asignado");
  const cProj = find("Project", "Proyecto");

  if (!cTitle) return null;

  return r.data
    .map(row => ({
      id: uid(),
      jira: cKey ? (row[cKey] || "") : "",
      titulo: cTitle ? (row[cTitle] || "") : "",
      responsable: cAssign ? (row[cAssign] || "") : "",
      proyecto: cProj ? (row[cProj] || "") : "",
      avances: []
    }))
    .filter(t => t.titulo.trim());
}

// CLIPBOARD 
export function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  } else {
    // Fallback para navegadores antiguos o contextos no seguros
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "absolute";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    return Promise.resolve();
  }
}

// DOCX PARSING USING MAMMOTH.JS
export async function parseDocx(arrayBuffer, userName) {
  if (typeof window.mammoth === "undefined") {
    throw new Error("La librería Mammoth.js no está cargada. Por favor, recarga la página.");
  }

  const result = await window.mammoth.convertToHtml({ arrayBuffer });
  const html = result.value;
  console.log("[DOCX Import] HTML generado por Mammoth:", html);

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const children = Array.from(doc.body.children);

  const tasks = [];
  let currentTask = null;
  const jiraRegex = /([A-Za-z]+-\d+)/;

  children.forEach(el => {
    const text = (el.textContent || "").trim();
    if (!text) return;

    const hasJiraKey = jiraRegex.test(text);
    const isHeading = ["H1", "H2", "H3", "H4", "H5", "H6"].includes(el.tagName);
    const isStrong = el.querySelector("strong") !== null || el.tagName === "STRONG";
    const isListItem = el.tagName === "LI" || el.closest("ul") || el.closest("ol");

    if (hasJiraKey && !isListItem && (isHeading || isStrong || !currentTask || el.tagName === "P")) {
      const match = text.match(jiraRegex);
      const jiraKey = match ? match[1].toUpperCase() : "";

      // Determine responsible based on keywords in the task title
      const lowerText = text.toLowerCase();
      let responsible = "Damaris Silva";
      const namesList = ["valen", "eze", "juani", "demian"];
      for (const name of namesList) {
        if (lowerText.includes(name)) {
          responsible = name.charAt(0).toUpperCase() + name.slice(1);
          break;
        }
      }

      currentTask = {
        id: uid(),
        titulo: text,
        jira: jiraKey,
        proyecto: "",
        responsable: responsible,
        prioridad: "normal",
        descripcion: "",
        avances: []
      };
      tasks.push(currentTask);
    } else {
      if (currentTask) {
        if (el.tagName === "UL" || el.tagName === "OL") {
          const lis = el.querySelectorAll("li");
          lis.forEach(li => {
            const liText = (li.textContent || "").trim();
            if (liText) {
              currentTask.avances.push({
                id: uid(),
                fecha: new Date().toISOString(),
                autor: userName || "Importador DOCX",
                texto: liText,
                estado: "Avanzando"
              });
            }
          });
        } else {
          currentTask.avances.push({
            id: uid(),
            fecha: new Date().toISOString(),
            autor: userName || "Importador DOCX",
            texto: text,
            estado: "Avanzando"
          });
        }
      }
    }
  });

  console.log("[DOCX Import] Tareas extraídas del DOCX:", tasks);
  return tasks;
}

